import { z } from "zod";

const addressBlockSchema = z
  .object({
    region_id: z.number({ message: "validation.addresses.region_required" }),
    region_city_type: z.enum(["region", "national_city"], { message: "validation.addresses.region_required" }),
    city_id: z.number().optional(),
    street: z.string().min(1, { message: "validation.addresses.street_required" }),
    home_number: z.string().min(1, { message: "validation.addresses.home_required" }),
    apartment_number: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.region_city_type === "region" && (data.city_id === undefined || Number.isNaN(data.city_id))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "validation.addresses.city_required",
        path: ["city_id"],
      });
    }
  });

export const addressesSchema = z.object({
  registration: addressBlockSchema,
  factual: addressBlockSchema,
});

export type AddressesFormValues = z.infer<typeof addressesSchema>;
